
/***
 * 姓名 :D
 * 创建时间:2019-3-8
 * 描述：路由复用服务
 * 更新记录：
 */

import { ActivatedRouteSnapshot, RouteReuseStrategy, DetachedRouteHandle } from '@angular/router';
import { ComponentRef } from '@angular/core';
import { environment } from 'src/environments/environment';


interface IRouteConfigData {
  reuse: boolean;
}

interface ICachedRoute {
  handle: DetachedRouteHandle;
  data: IRouteConfigData;
}
export class SwSimpleReuseStrategy implements RouteReuseStrategy {
    private static routeCache = new Map<string, ICachedRoute>();
    private static waitDelete: string; // 当前页未进行存储时需要删除
    private static currentDelete: string;  // 当前页存储过时需要删除
  
    /** 进入路由触发，判断是否是同一路由 ,加入了参数id的判断 ,使用方法:
     * 1.在路由文件中配置 如: path: 'CulLoginView/:id', component: LoginViewComponent ,
     * 2.跳转路由的时候,带上id, 如:this.router.navigate([event.url+'/'+event.businessId], { queryParams: { Title: event.flowName} });*/
    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
     // return future.routeConfig === curr.routeConfig;
      let isRead = future.routeConfig === curr.routeConfig && JSON.stringify(future.params) == JSON.stringify(curr.params)
      return isRead;
    }
  
    /** 表示对所有路由允许复用 如果你有路由不想利用可以在这加一些业务逻辑判断，这里判断是否有data数据判断是否复用 */
    shouldDetach(route: ActivatedRouteSnapshot): boolean {
      //先看是支持多页签还是单页签， 如果是单页签， 就不需要路由复用， 一直返回false
      let singleTab = environment.singleTab
      if(singleTab){
        //支持单页签
        return false
      } else {
        // 支持多页签
        const data = this.getRouteData(route);
        if (data && data["routereuse"] ) {
          return true;
        }
        return false;
      }
    }
  
    /** 当路由离开时会触发。按path作为key存储路由快照&组件当前实体对象 */
    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
      const url = this.getFullRouteUrl(route);
      const data = this.getRouteData(route);
      if (SwSimpleReuseStrategy.waitDelete && SwSimpleReuseStrategy.waitDelete === url) {
        // 如果待删除是当前路由，且未存储过则不存储快照
        SwSimpleReuseStrategy.waitDelete = null;
        //SwSimpleReuseStrategy.routeCache.set(url, { handle, data });
        const oldHandle = handle as { componentRef: ComponentRef<any> };
        oldHandle.componentRef.destroy();
        return null;
      }else {
        // 如果待删除是当前路由，且存储过则不存储快照
        if (SwSimpleReuseStrategy.currentDelete && SwSimpleReuseStrategy.currentDelete === url) {
          const oldHandle = handle as { componentRef: ComponentRef<any> };
          oldHandle.componentRef.destroy();
            SwSimpleReuseStrategy.currentDelete = null;
          return null;
        }else {
          try{
            if(handle == null) {
              const oldHandle = SwSimpleReuseStrategy.routeCache.get(url).handle as { componentRef: ComponentRef<any> };
              oldHandle.componentRef["_component"]._OnReuseInit()
            }else{
              const oldHandle = SwSimpleReuseStrategy.routeCache.get(url).handle as { componentRef: ComponentRef<any> };
              oldHandle.componentRef["_component"]._OnReuseDestroy()
            }
          }catch(e){}
          if(handle != null )
         
              SwSimpleReuseStrategy.routeCache.set(url, { handle, data });
          this.addRedirectsRecursively(route);
        }
      }
    }
  
    /** 若 path 在缓存中有的都认为允许还原路由 */
    shouldAttach(route: ActivatedRouteSnapshot): boolean {
      const url = this.getFullRouteUrl(route);
      return SwSimpleReuseStrategy.routeCache.has(url);
    }
  
    /** 从缓存中获取快照，若无则返回nul */
    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
      const url = this.getFullRouteUrl(route);
      const data = this.getRouteData(route);
      let handle =null;
      if( data  && SwSimpleReuseStrategy.routeCache.has(url)){
        handle = SwSimpleReuseStrategy.routeCache.get(url).handle
      }
      return handle;

    }
  
    private addRedirectsRecursively(route: ActivatedRouteSnapshot): void {
      const config = route.routeConfig;
      if (config) {
        if (!config.loadChildren) {
          const routeFirstChild = route.firstChild;
          const routeFirstChildUrl = routeFirstChild ? this.getRouteUrlPaths(routeFirstChild).join('/') : '';
          const childConfigs = config.children;
          if (childConfigs) {
            const childConfigWithRedirect = childConfigs.find(c => c.path === '' && !!c.redirectTo);
            if (childConfigWithRedirect) {
              childConfigWithRedirect.redirectTo = routeFirstChildUrl;
            }
          }
        }
        route.children.forEach(childRoute => this.addRedirectsRecursively(childRoute));
      }
    }
  
    private getFullRouteUrl(route: ActivatedRouteSnapshot): string {
       // return this.getFullRouteUrlPaths(route).filter(Boolean).join('/').replace('/', '_');
       return this.getFullRouteUrlPaths(route).filter(Boolean).join('/').replace(/\//g,'_');
    }
  
    private getFullRouteUrlPaths(route: ActivatedRouteSnapshot): string[] {
      const paths = this.getRouteUrlPaths(route);
      return route.parent ? [ ...this.getFullRouteUrlPaths(route.parent), ...paths ] : paths;
    }
  
    private getRouteUrlPaths(route: ActivatedRouteSnapshot): string[] {
      return route.url.map(urlSegment => urlSegment.path);
    }
  
    private getRouteData(route: ActivatedRouteSnapshot): IRouteConfigData {
      return route.routeConfig && route.routeConfig.data as IRouteConfigData;
    }
  
    /** 用于删除路由快照*/
    public static deleteRouteSnapshot(url: any): void {
      if (url[0] === '/') {
        url = url.substring(1);
      }
    // url = url.replace('/', '_');
     url = url.replace(/\//g,'_');
      if (SwSimpleReuseStrategy.routeCache.has(url)) {
        const oldHandle = SwSimpleReuseStrategy.routeCache.get(url).handle as { componentRef: ComponentRef<any> };
        oldHandle.componentRef.destroy();
        SwSimpleReuseStrategy.routeCache.delete(url);
        SwSimpleReuseStrategy.currentDelete = url;

      }else {
        SwSimpleReuseStrategy.waitDelete = url;
      }
    
    }

  //删除全局缓存快照
  public static deleteAllRouteSnapshot() {
    SwSimpleReuseStrategy.routeCache.forEach((value,Key,map)=>{
      SwSimpleReuseStrategy.deleteRouteSnapshot(Key)
    })
  }

  //获取全局缓存快照
  public static getRouterCache() {
    return SwSimpleReuseStrategy.routeCache
  }
    
}